import React from 'react';
import { Paper, Typography } from '@mui/material';
import { TooltipProps } from 'recharts';
import { ValueType, NameType, Payload } from 'recharts/types/component/DefaultTooltipContent';

import { DateTimeFormat, formatDateTime, parseDate } from '../../../../lib/date';

export const AudienceSizeChartTooltip: React.FC<TooltipProps<ValueType, NameType>> = ({
  label,
  payload,
}) => {
  const tooltipPayload: Payload<ValueType, NameType> | null = payload?.length ? payload[0] : null;
  if (!tooltipPayload) {
    return null;
  }
  const { name, value } = tooltipPayload;

  return (
    <Paper sx={{ p: 2 }}>
      <Typography color='primary' gutterBottom>
        Members
      </Typography>
      <Typography variant='body2' sx={{ textTransform: 'capitalize' }}>
        {`${name}: `}
        <Typography variant='subtitle2' color='primary' component='span'>
          {value}
        </Typography>
      </Typography>
      <Typography variant='body2' sx={{ textTransform: 'capitalize' }}>
        {'Date: '}
        <Typography variant='subtitle2' component='span'>
          {formatDateTime(parseDate(label), DateTimeFormat.DateTime12h)}
        </Typography>
      </Typography>
    </Paper>
  );
};
